import { httpClient } from "../http/httpClient";

export interface IncreaseEntryCountParams {
  name: string;
}

export interface EntryCount {
  entryAt: string;
}

export interface SelfHiringLink {
  _id: string;
  name: string;
  label: string;
  seller: string;
  tables: string[];
  entry_count: EntryCount[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface IncreaseEntryCountResponse {
  selfHiringLink: SelfHiringLink;
}

export async function increaseEntryCount(
  params: IncreaseEntryCountParams,
): Promise<IncreaseEntryCountResponse> {
  const { data } = await httpClient.patch<IncreaseEntryCountResponse>(
    "/self-hire",
    null,
    {
      params,
    },
  );

  return data;
}
